import React from 'react';
import Draggable from 'react-draggable';
import {useTranslation} from 'react-i18next';
import {useStorageState} from 'react-storage-hooks';
import {version as pdfjsVersion} from 'pdfjs-dist';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.js?url';
import {Worker, Viewer} from '@react-pdf-viewer/core';
import {defaultLayoutPlugin} from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// https://react-pdf-viewer.dev/localizations/
import fr_FR from '@react-pdf-viewer/locales/lib/fr_FR.json';

export const PDFJS_VERSION = pdfjsVersion;
export const PDFJS_WORKER_URL = pdfWorkerUrl;

export const transformPdfDocumentParams = params => ({
    ...params,
    // Retain the documented mitigation for CVE-2024-4367. This must be passed
    // to pdfjs.getDocument through the viewer's supported transform hook.
    isEvalSupported: false,
});

const PdfViewer = ({url, style={}})=>{
    const {i18n} = useTranslation();

    const transform = slot => ({
        ...slot,
        Download: () => <></>,
        DownloadMenuItem: () => <></>,
        Open: () => <></>,
        OpenMenuItem: () => <></>,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
        RotateBackwardMenuItem: () => <></>,
        RotateForwardMenuItem: () => <></>,
        ShowPropertiesMenuItem: () => <></>,
    });
    const renderToolbar = Toolbar => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    );
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
    });
    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance;

    const [height, setHeight] = useStorageState(sessionStorage, 'pdfViewerHeight', 750);

    const onDrag = e=>{
        setHeight(e.clientY);
    };

    const onDragStop = e=>{
        setHeight(e.clientY);
    };

    let locale;
    switch(i18n.language) {
        case 'fr':
            locale = fr_FR;
    }

    return (
        <>
            <Worker workerUrl={PDFJS_WORKER_URL}>
                <div
                    style={{
                        backgroundColor: 'white',
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height,
                        ...style
                    }}
                >
                    <Viewer
                        fileUrl={url}
                        plugins={[defaultLayoutPluginInstance]}
                        localization={locale}
                        transformGetDocumentParams={transformPdfDocumentParams}
                    />
                </div>
            </Worker>

            <Draggable axis="y" onDrag={onDrag} onStop={onDragStop} defaultPosition={{y:0}}>
                <div style={{position: 'fixed', width: '100%', height:'3px', cursor:'row-resize', zIndex: 9999}}/>
            </Draggable>
        </>
    );
};

export default PdfViewer;
